const path = require('path');

// 本地 devServer 地址
const LOCAL_SERVER = {
  HOST: '127.0.0.1',
  PORT: '8088',
};

// 组件库根目录
const ROOT_PATH = process.cwd();

// 组件库打包输出目录
const DIST_PATH = path.resolve(ROOT_PATH, 'dist');

// 组件本地调试目录
const DEV_PATH = path.resolve(ROOT_PATH, '__dev__');

// 平台
const Platform = {
  PlatformCMS: 'cms', // CMS
  PlatformH5: 'h5', // H5
  PlatformH5React: 'h5_react', // H5 React 版本
  PlatformMP: 'mp', // 小程序
  PlatformIOS: 'ios', // IOS 客户端
  PlatformAndroid: 'android', // Android 客户端
};

const SERVER_URLS = {
  [Platform.PlatformH5]: `/manifest.comp.json`,
  [Platform.PlatformCMS]: `/manifest.cms.json`,
  meta: `/meta.json`,
};

module.exports = {
  LOCAL_SERVER,
  ROOT_PATH,
  DIST_PATH,
  DEV_PATH,
  SERVER_URLS,
};
